// extracted by mini-css-extract-plugin
module.exports = {"layoutContain":"Layout_layoutContain__zvKNE","layoutSider":"Layout_layoutSider__cbDJS"};